var jsProduct = {
  defaultSize: "",
  cartId: "",
  upSizeDomHtml:
    "<button onclick='jsProduct.chooseUpSize({{UPSIZE_ID}})'  class='product-sizes-widget__upsize-button' type='button' aria-label='upsize'>" +
    "<span>Upsize to {{UPSIZE_NAME}} +${{UPSIZE_PRICE}}</span>" +
    "</button>" +
    "<p class='product-sizes-widget__upsize-notify'>By clicking on the button you will select the following crystal size</p>",
  productInit: function (_defaultSize) {
    jsProduct.defaultSize = _defaultSize;
    jsProduct.cartId = jsProduct.generateRandomNumber();
    setTimeout("jsProduct.showDefaultLightBase()", 500);

    $("#frmCart").append(
      "<input type='hidden' name='properties[CART_ID]' value='" +
        jsProduct.cartId +
        "'>"
    );
  },

  generateRandomNumber: function () {
    return Math.floor(Math.random() * 10000); // Generates a random number between 0 and 999999
  },

  showDefaultLightBase: function () {
    $("#divLightBase_" + jsProduct.defaultSize).show();
    $("#divLightBase_" + jsProduct.defaultSize).append(
      "<input type='hidden' id='cartIDLightBase' value='" +
        jsProduct.cartId +
        "' />"
    );

    //Init
    $("#cartIDAccessories").append(
      "<input type='hidden' id='cartIDAccessories' value='" +
        jsProduct.cartId +
        "' />"
    );

    localStorage.setItem(
      "AccessoriesHtml_" + jsProduct.cartId,
      $("#divAccessoriesHtml").html()
    );

    $("#divLightBase_" + jsProduct.defaultSize).append(
      "<input type='hidden' id='cartIDLightBase' value='" +
        jsProduct.cartId +
        "' />"
    );
    localStorage.setItem(
      "LightBaseHtml_" + jsProduct.cartId,
      $("#divLightBase_" + jsProduct.defaultSize).html()
    );

    jsProduct.calculateTotal();
  },

  openUploadImage: function () {
    $(".photo-editor-library-notificator").hide();
    $(".pplrfileuploadbutton > input[type=file]")[0].click();
  },

  calculateTotal: function () {
    var totalPrice = 0;
    var cartProductId = "";
    $(".chooseVariant").each(function (key, obj) {
      var price = $(obj).attr("data-price").replace(",", "");
      var productId = $(obj).attr("value");
      totalPrice += parseFloat(price);
      cartProductId += productId + ",";
      console.log(totalPrice);
    });

    $(".spTotal").html(totalPrice.toLocaleString());
  },
  needShowUpSize: true,
  chooseUpSize: function (obj) {
    $(".product_choose_size").removeAttr("checked");
    $("#size_" + obj).attr("checked", "checked");

    jsProduct.needShowUpSize = false;
    $("#size_" + obj).click();
  },

  chooseSize: function (obj) {
    var dataId = $(obj).attr("data-value");
    var dataPrice = $(obj).attr("data-price");   

    $(".product_choose_size").removeClass("active");
    $(obj).addClass("active");
$('#divFreeKeychain').show();
    $("#chooseSize").val(dataId);
    $("#chooseSize").attr("data-price", dataPrice);
    $(".lightbase").hide();
    $("#divLightBase_" + dataId).show();
    $("#divLightBase_" + dataId).append(
      "<input type='hidden' id='cartIDLightBase' value='" +
        jsProduct.cartId +
        "' />"
    );
    try{
    localStorage.setItem(
      "LightBaseHtml_" + jsProduct.cartId,
      $("#divLightBase_" + dataId).html()
    );
    }catch{}
    jsProduct.calculateTotal();

    var attrShow = $("#lblSize_" + dataId).attr("data-show");
    if (attrShow == 0) {
      //$(".product-size-item").slideUp(200);
      //$("#lblSize_" + dataId).slideDown(0);
      $("#lblSize_" + dataId).attr("data-show", 1);

      $(".col-size").removeClass("active");
      $("#col-size-" + dataId).addClass("active");
    } else {
      $(".product-size-item").show();
      $(".product-size-item").attr("data-show", 0);
    }
    //jsProduct.showUpSize(dataId, dataPrice);
    // jsProduct.needShowUpSize = true;
    return;
  },

  showUpSize: function (dataId, dataPrice) {
    if (!jsProduct.needShowUpSize) {
      $("#divUpSize").html("");
      return;
    }
    //Show Upsize
    let lstProductSizes = $(".product_choose_size");
    let currentIndex = 0;
    for (let i = 0; i < lstProductSizes.length; i++) {
      if ($(lstProductSizes[i]).attr("data-value") == dataId) {
        currentIndex = i;
        break;
      }
    }
    $("#divUpSize").html("");
    if (currentIndex + 1 < lstProductSizes.length) {
      var selectNextSize = lstProductSizes[currentIndex + 1];
      var upPrice = parseFloat($(selectNextSize).attr("data-price"));
      var nextSizeHtml = jsProduct.upSizeDomHtml
        .replace("{{UPSIZE_ID}}", $(selectNextSize).attr("data-value"))
        .replace("{{UPSIZE_NAME}}", $(selectNextSize).attr("data-name"))
        .replace("{{UPSIZE_PRICE}}", upPrice - parseFloat(dataPrice));
      $("#divUpSize").html(nextSizeHtml);
    }
  },
  chooseBackground: function (obj) {
    var dataValue = $(obj).attr("data-value");
    var dataPrice = $(obj).attr("data-price");
    if (dataValue == 0) {
      $("#divBackground").html("");
    } else
      $("#divBackground").html(
        "<input type='hidden' name='items[1][id]' class='chooseVariant' id='chooseBackground' value='" +
          dataValue +
          "' data-price='" +
          dataPrice +
          "'><input type='hidden' name='items[1][quantity]' value='1'><input type='hidden' name='items[1][properties][CART_ID]' value='" +
          jsProduct.cartId +
          "'>"
      );

    jsProduct.calculateTotal();
  },

  chooseNoLightBase: function () {
    $(".product-light-base").removeClass("active");
    $("#divLightBase").html("");
    $(".divLightBaseCustomText").hide();
   $('#txtLightBaseCustomText').removeAttr('required');
  },

  chooseLightBase: function (obj) {
    var dataPrice = $(obj).attr("data-price");
    var dataId = $(obj).attr("data-id");
    var dataCustomText = $(obj).attr("data-custom-text");

    $(".divLightBaseCustomText").hide();
    $('#txtLightBaseCustomText').removeAttr('required');
    if (dataCustomText === "true") 
    {
      $(".divLightBaseCustomText").show();
      $('#txtLightBaseCustomText').attr('required');
    }

    $(".product-light-base").removeClass("active");

    $(obj).addClass("active");

    $("#divLightBase").html(
      "<input type='hidden' name='items[2][id]' value='" +
        dataId +
        "' class='chooseVariant' data-price='" +
        dataPrice +
        "'><input type='hidden' name='items[2][quantity]' value='1'><input type='hidden' name='items[2][properties][CART_ID]' value='" +
        jsProduct.cartId +
        "'>"
    );

    jsProduct.calculateTotal();
  },

  chooseAccessories: function (obj) {
    //$(".product-light-base").removeClass("active");
    if ($(obj).hasClass("active")) $(obj).removeClass("active");
    else $(obj).addClass("active");

    $selectedAccessories = $(".product-accessory.active");
    $("#divAccessories").html("");
    var ind = 3;
    $.each($selectedAccessories, function (key, item) {
      var dataPrice = $(item).attr("data-price");
      var dataId = $(item).attr("data-id");

      $("#divAccessories").append(
        "<input type='hidden' name='items[" +
          ind +
          "][id]' value='" +
          dataId +
          "' class='chooseVariant' data-price='" +
          dataPrice +
          "'><input type='hidden' name='items[" +
          ind +
          "][quantity]' value='1'><input type='hidden' name='items[" +
          ind +
          "][properties][CART_ID]' value='" +
          jsProduct.cartId +
          "'>"
      );
      ind++;
    });

    jsProduct.calculateTotal();
  },

  showLightBase: function () {
    var var_best_seller = $("#var_best_seller").val();
    $("#lightbase_" + var_best_seller).show();
  },

  addCart: function () {
    return true;
  },
};

var timer2 = "60:00";
var interval = setInterval(function () {
  var timer = timer2.split(":");
  //by parsing integer, I avoid all extra string processing
  var minutes = parseInt(timer[0], 10);
  var seconds = parseInt(timer[1], 10);
  --seconds;
  minutes = seconds < 0 ? --minutes : minutes;
  seconds = seconds < 0 ? 59 : seconds;
  seconds = seconds < 10 ? "0" + seconds : seconds;
  //minutes = (minutes < 10) ?  minutes : minutes;
  $("#product-countdown-timer__number_minutes").html(minutes);
  $("#product-countdown-timer__number_seconds").html(seconds);
  if (minutes < 0) clearInterval(interval);
  //check if both minutes and seconds are 0
  if (seconds <= 0 && minutes <= 0) clearInterval(interval);
  timer2 = minutes + ":" + seconds;
}, 1000);
